import React from "react";
import { Component } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer } from 'recharts';
import CustomTooltip from "./custom-tooltip.component";

export class LineChartData extends Component {
    render(){
        const { firstLineColor, toolTipEnable, secondLineColor, thirdLineColor, lineYAxis, usageSpendLineData, currencySymbol}=this.props;
        console.log('usageSpendLineData', usageSpendLineData)
        return(
        <div className="width-p100">
            <ResponsiveContainer width="100%" height={200}>
          <LineChart
            width={500}
            height={200}
            data={usageSpendLineData}
            margin={{
              top: 10,
              right: 20,
              left: -30,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#dfe3e8" />
            <XAxis stroke="#dfe3e8" tick={{fontSize: 11, fill: '#919eab'}} dataKey="Month" />
            <YAxis stroke="#dfe3e8" type="number" ticks={lineYAxis}  tick={{fontSize: 11, fill: '#919eab'}}/>
            <Tooltip/>
            
            <ReferenceLine x="May" stroke="red" />
            <Line connectNulls type="Graphik-Regular" unit={currencySymbol} dataKey="Voice" stroke={firstLineColor} fill={firstLineColor} activeDot={{ r: 8 }} />
            <Line connectNulls type="Graphik-Regular" unit={currencySymbol} dataKey="Messaging" stroke={secondLineColor}  fill={secondLineColor} activeDot={{ r: 8 }} />
            <Line connectNulls type="Graphik-Regular" unit={currencySymbol} dataKey="Data" stroke={thirdLineColor} fill={thirdLineColor} activeDot={{ r: 8 }}/>
          </LineChart>
        </ResponsiveContainer>
        </div>
        );
    }
}